// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Need both of the following because of specificity rules*/
.github-markdown-toolbar .ecl-markdown-button .ecl-select-new button,
.github-markdown-toolbar .ecl-markdown-button button{
   height: 25px;
   width: 25px;
   max-width: 25px;
   min-width: 25px;
   padding: 0;
   border-radius: 0;
}

.github-markdown-toolbar .ecl-markdown-button .ecl-select-new button:hover,
.github-markdown-toolbar .ecl-markdown-button button:hover {
   background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLRichText/ECLRichTextEditor/EditorToolbar.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;;GAEG,YAAY;GACZ,WAAW;GACX,eAAe;GACf,eAAe;GACf,UAAU;GACV,gBAAgB;AACnB;;AAEA;;GAEG,6BAA6B;AAChC","sourcesContent":["/* Need both of the following because of specificity rules*/\r\n.github-markdown-toolbar .ecl-markdown-button .ecl-select-new button,\r\n.github-markdown-toolbar .ecl-markdown-button button{\r\n   height: 25px;\r\n   width: 25px;\r\n   max-width: 25px;\r\n   min-width: 25px;\r\n   padding: 0;\r\n   border-radius: 0;\r\n}\r\n\r\n.github-markdown-toolbar .ecl-markdown-button .ecl-select-new button:hover,\r\n.github-markdown-toolbar .ecl-markdown-button button:hover {\r\n   background-color: transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
